import React from 'react';

import AlertIcon from 'assets/alert.svg';

import TabSwitcher, { TabOption } from '../../../common/TabSwitcher/TabSwitcher';
import { useShipment } from '../../hooks/shipment.hooks';
import {
  TAB_JOURNEY_INPUT_TEST_ID,
  TAB_OVERVIEW_INPUT_TEST_ID,
  TAB_SWITCHER_TEST_ID,
} from './TrackingTabSwitcher.test-ids';

export enum TrackingTabSwitcherOptions {
  OVERVIEW = `overview`,
  JOURNEY = `journey`,
}

export interface TrackingTabSwitcherProps {
  activeTab: TrackingTabSwitcherOptions | string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const TrackingTabSwitcher: React.FC<TrackingTabSwitcherProps> = ({ activeTab, onChange }) => {
  const notices = useShipment()?.dynamicCommsList ?? [];
  const disruptionNotices = notices.filter((notice) => notice.type === 'DISRUPTION').slice(0, 3);

  const disruptionAlert =
    disruptionNotices.length > 0 ? (
      <AlertIcon id='JourneyAlert' aria-label='contains an alert about a possible disruption' role='img' />
    ) : null;

  const tabs: TabOption[] = [
    {
      value: TrackingTabSwitcherOptions.OVERVIEW,
      label: 'Overview',
      ariaControls: 'OverviewTabPanel',
      testId: TAB_OVERVIEW_INPUT_TEST_ID,
    },
    {
      value: TrackingTabSwitcherOptions.JOURNEY,
      label: 'Journey',
      ariaControls: 'JourneyTabPanel',
      testId: TAB_JOURNEY_INPUT_TEST_ID,
      ariaDescribedBy: 'JourneyAlert',
      icon: disruptionAlert,
      iconPosition: 'right',
    },
  ];

  return (
    <TabSwitcher
      activeTab={activeTab}
      tabs={tabs}
      onChange={onChange}
      ariaLabelledBy='trackingPanelHeading'
      data-testid={TAB_SWITCHER_TEST_ID}
    />
  );
};

export default TrackingTabSwitcher;
